// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBv8dq0_r4DQHxrATjlpkWhmYWe2F7QIY4",
  authDomain: "hicardi-3f16c.firebaseapp.com",
  projectId: "hicardi-3f16c",
  storageBucket: "hicardi-3f16c.appspot.com",
  messagingSenderId: "620980520192",
  appId: "1:620980520192:web:14796f8aac4221dee11fe5",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
